module.exports = __webpack_public_path__ + "img/0829-chevron-right.4206aed9.svg";